import { create } from 'zustand';

interface ToastState {
	toastActived: boolean;
	status: string;
	text: string;
	layout: string;
	className: string;
	fields?: string[] | null | undefined;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	timeRef: any;
	openToast: (OpenParams: OpenParams) => void;
	closeToast: () => void;
}

interface OpenParams {
	text: string;
	status: string;
	layout?: string;
	className?: string;
	fields?: string[] | null | undefined;
	time?: number | undefined | null;
}

export const useToastStore = create<ToastState>((set, get) => ({
	toastActived: false,
	status: '',
	text: '',
	layout: '',
	className: '',
	fields: [],
	timeRef: null,
	openToast: async ({
		text = '',
		status = 'danger',
		layout = 'default',
		className = '',
		fields = [],
		time = 5000,
	}: OpenParams) => {
		get().toastActived && (await get().closeToast());

		set((state) => {
			state.text = text;
			state.status = status;
			state.layout = layout;
			state.className = className;
			state.fields = fields;
			state.toastActived = true;

			if (time !== null) {
				state.timeRef = setTimeout(() => {
					get().closeToast();
				}, time);
			}

			return { ...state };
		});
	},
	closeToast: () =>
		set((state) => {
			clearTimeout(state.timeRef);
			state.toastActived = false;
			state.text = '';
			state.status = '';
			state.layout = '';
			state.className = '';
			state.fields = [];

			return { ...state };
		}),
}));
